import { render, staticRenderFns } from "./TheGiftCard.vue?vue&type=template&id=540d490b&scoped=true"
import script from "./TheGiftCard.vue?vue&type=script&lang=js"
export * from "./TheGiftCard.vue?vue&type=script&lang=js"
import style0 from "./TheGiftCard.vue?vue&type=style&index=0&id=540d490b&prod&lang=scss&scoped=true"
import style1 from "./TheGiftCard.vue?vue&type=style&index=1&id=540d490b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d490b",
  null
  
)

export default component.exports